import { m } from '../../mithril';
import { Icon } from '../icon';
import { MaterialIcon } from '../icon/icons';
import { addStyles, DefaultTheme } from '../theme';

export interface CheckBoxState {
	isSelected: () => boolean;
	setSelected: (val: boolean) => void;
	isIndeterminate?: () => boolean;
	isDisabled?: boolean;
}

export const CSS = {
	container: 'c-CheckBox',
	isSelected: 'c-CheckBox--selected',
	isIndeterminate: 'c-CheckBox--indeterminate',
	isDisabled: 'c-CheckBox--disabled',
};

addStyles({
	[CSS.container]: {
		userSelect: 'none',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		overflow: 'hidden',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.isSelected]: {
		color: DefaultTheme.font.color.link,
	},
	[CSS.isIndeterminate]: {
		color: DefaultTheme.font.color.link,
	},
	[CSS.isDisabled]: {
		color: DefaultTheme.font.color.disabled,
	},
});

export const CheckBox = {
	view(state: CheckBoxState) {
		const isSelected = state.isSelected() === true;
		let className = CSS.container;
		let materialIcon: MaterialIcon = MaterialIcon.CHECK_BOX;

		if (isSelected) {
			className += ' ' + CSS.isSelected;
			materialIcon = MaterialIcon.CHECK_BOX_SELECTED;
		} else if (state.isIndeterminate != null && state.isIndeterminate()) {
			className += ' ' + CSS.isIndeterminate;
			materialIcon = MaterialIcon.CHECK_BOX_INDETERMINATE;
		}

		if (state.isDisabled) {
			className += ' ' + CSS.isDisabled;
		}

		return m(
			'div',
			{
				className,
				onclick: !state.isDisabled
					? (ev: MouseEvent) => {
							ev.stopPropagation();
							state.setSelected(!isSelected);
						}
					: null,
			},
			Icon.view(materialIcon)
		);
	},
};
